<template>
  <div ref="news" class="news">
    <payPage ref="pay"></payPage>
    <!-- banner栏 -->
    <div class="banner">
      <div class="bannerText">
        <div>
          <h3>新闻与资讯</h3>
          <p>关于我们的最新资讯动态</p>
        </div>
      </div>
      <div class="bannerImg">
        <img src="../assets/images/img_newsBg.jpg" alt="">
      </div>
    </div>
    <div class="newsBox">
      <div class="currencyTitle">
        <img src="../assets/images/logoTitle.png" alt="">
        <h3>新闻与资讯</h3>
      </div>
      <div class="newList">
        <ul>
          <li class="animate__animated animate__fadeInUp" v-for="(item,index) in arrList" :key="index" @click="getInfo(item)">
            <div class="newsImg">
              <img :src="item.coverImage" alt="">
            </div>
            <div class="newsInner">
              <div class="newsInnerU">
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
              </div>
              <div class="newsInnerD">
                <span>{{ item.releaseDate }}</span>
                <img v-if="item.charge === 0" src="../assets/images/img_more01.png" alt="">
                <a v-else href="javascript:void(0);" class="comButton collection-1 btn-15">
                  <span>付费信息2元/条</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
     <!-- 底部 定制 -->
     <div class="styleBox_07" :style="{backgroundImage:'url('+ bgUrl +')'}">
      <p>智能化网络安全保障服务，即刻开启！</p>
      <a href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span @click="toPlan">立即定制</span>
      </a>
    </div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
import payPage from '@/components/comForPc/payPage.vue'
export default {
  components: { Header, Sidebar, Footer, payPage },
  data () {
    return {
      pageTips: '',
      arrList: [],
      bgUrl: ''
    }
  },
  methods: {
    // 获取导航数据ioo
    getAbout () {
      let arr = JSON.parse(localStorage.getItem('navList'))
      arr.forEach(item => {
        if (item.id == this.pageTips) {
          this.arrList = item.articleList
        }
      })
      // coverImage
      this.arrList.forEach(item => {
        if(item.releaseDate){
          item.releaseDate = item.releaseDate.split(' ')[0]
        }
      })
      console.log(this.arrList)
    },
    getInfo (data) {
      if (data.charge === 0) {
        this.$router.push({path: '/newsInfo', query: {id: data.id}})
      } else {
        this.$refs.pay.showDialog()
      }
    },
    toPlan () {
      this.$router.push('/getPlan')
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.id) { this.pageTips = this.$route.query.id }
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
    this.getAbout()
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>

// 移动端样式
@media only screen and (max-width: 1024px) {
  .news{
    padding-top: 2.75rem;
  }
  .banner {
    width: 100%;
    position: relative;
  }
  .bannerImg {
    width: 100%;
  }
  .bannerImg img {
    width: 100%;
  }
  .bannerText {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bannerText div {
    text-align: center;
  }
  .bannerText h3 {
    font-size: 1.0625rem;
    font-weight: bold;
    border: 0.0625rem solid #fff;
    padding: 0.75rem 1.5rem;
    display: inline-block;
    margin: 0;
    margin-bottom: 0.93rem;
  }
  .bannerText p {
    font-size: 0.6375rem;
    margin: 0;
  }
  .bannerText p {
    font-size: 0.9375rem;
    margin: 0;
  }
  .currencyTitle {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .currencyTitle img {
    width: 2.1rem;
    height: 1.75rem;
  }
  .currencyTitle h3 {
    font-size: 1.0625rem;
    font-weight: 600;
    color: #08142a;
    margin: 0;
    margin-left: 0.6875rem;
    padding: 2.625rem 0;
  }
  .newList{
    width: 80%;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .newList .newsImg{
    width: 100%;
    margin-bottom: 1.25rem;
  }
  .newList .newsImg img{
    width: 100%;
  }
  .newList li{
    background: #FFFFFF;
    box-shadow: 0px .125rem .3125rem 0px rgba(204,204,204,0.5);
    border-radius: .25rem;
    margin-bottom: 1.25rem;
  }
  .newList li h5{
    font-size: 1rem;
    font-weight: 600;
    color: #353535;
    line-height: 1.875rem;
    padding: 0 1.25rem;
  }
  .newsInner{
    padding: 0 1.25rem;
    .newsInnerU{
      h4{
        font-size: 1rem;
        font-weight: 600;
        color: #353535;
        line-height: 1.875rem;
      }
      p{
        font-size: .875rem;
        font-weight: 300;
        color: #4C5461;
        line-height: 1.375rem;
      }
    }
    .newsInnerD{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 0;
      img{
        width: 1.875rem;
        height: 1.875rem;
      }
      span{
        font-size: .8125rem;
        font-weight: 300;
        color: #6F788C;
        line-height: 1.125rem;
      }
    }
  }
  .styleBox_07 {
    width: 100%;
    background-repeat:no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2.125rem 0 1.5625rem;
    margin-top: 1.25rem;
  }
  .styleBox_07 p {
    font-size: 1rem;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 1.5625rem;
  }
  .comButton {
    color: #fff;
    border-radius: 1rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 1.875rem;
    font-size: 0.8125rem;
    margin: 0;
    padding: 0;
    max-width: 6.6875rem;
    span{
        color: #fff !important;
      }
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .news{
    width: 100%;
    background: #fff;
    // 按钮样式
    // banner图部分
    .banner{
      position: relative;
      .bannerText{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        div{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3{
            font-size: 52px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 78px;
            letter-spacing: 5px;
            text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
            padding: 16px 51px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            margin-bottom: 37px;
          }
          p{
            font-size: 30px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 42px;
            letter-spacing: 2px;
          }
        }
      }
      .bannerImg{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .comButton{
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
      height: 50px;
      span{
        color: #fff !important;
      }
    }
    .btn-15:after{
      background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
    }
    // 通用标题
    .currencyTitle{
      display: flex;
      justify-content: center;
      margin: 110px 0 85px 0;
      img{
        width: 69px;
        height: 54px;
      }
      h3{
        color: #08142A;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-left: 22px;
      }
    }
    .newsBox{
      width: 100%;
      .newList{
        max-width: 1180px;
        margin: 0 auto;
        li{
          background: #FFFFFF;
          box-shadow: 3px 0px 9px 2px rgba(204,204,204,0.5);
          border-radius: 10px;
          padding: 27px 30px ;
          display: flex;
          margin-bottom:30px;
          cursor: pointer;
          border: 5px solid rgba(0, 0, 0, 0);
          .newsImg{
              width: 322px;
             margin-right: 27px;
             img{
              width: 322px;
             }
          }
          .newsInner{
            width: calc(100% - 350px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .newsInnerU{
              display: flex;
              flex-direction: column;
              h4{
                font-size: 20px;
                font-weight: 600;
                color: #353535;
                margin-bottom: 20px;
              }
              p{
                font-size: 16px;
                font-weight: 300;
                color: #4C5461;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
            .newsInnerD{
              display: flex;
              justify-content: space-between;
              align-items: center;
              span{
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 300;
                color: #6F788C;
              }
              img{
                width: 36px;
                height: 36px;
              }
            }
          }
        }
        li:hover{
          border: 5px solid #428BF8;
        }
      }
    }
    .styleBox_07 {
      width: 100%;
      height: 320px;
      background-repeat:no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 50px;
    }
    .styleBox_07 p {
      font-size: 32px;
      font-weight: 600;
      color: #08142a;
      margin-bottom: 44px;
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue